import Select from 'shared/components/Select'
import MediaQuery from 'react-responsive'

import { withRouter } from 'i18n/utils'
import DelayedInput from 'shared/components/DelayedInput'
import { GRID_BREAKPOINT_MD } from 'shared/breakpoints'

import { categoriesSelector, categorySelector } from '../selectors'

const CategoryLink = ({ active, icon, path, name }) => {
    const className = active ? 'active' : ''
    const iconClassName = `icon-${icon ? icon : 1}`

    return (
        <li className="m-0">
            <Link to={path} className={className} title={name}>
                <i className={`category ${iconClassName}`} />
                {name}
            </Link>
        </li>
    )
}

const CategoryList = ({ category, categories, onClick }) => (
    <div className="col-lg-8 filter-container">
        <span className="filter">
            <T>news.label.categories</T>:
        </span>

        <ul className="categories p-0">
            <CategoryLink active={category === false} name={<T>news.label.all.categories</T>} path={`/news`} />

            {Object.values(categories).map(({ id, name, count, icon, slug }) =>
                count > 0 ? (
                    <CategoryLink
                        id={id}
                        active={category && category.id === id}
                        key={id}
                        path={`/news/${slug}`}
                        name={name}
                        icon={icon}
                        onClick={onClick}
                    />
                ) : null
            )}
        </ul>
    </div>
)

class $CategoryListMobile extends Component {
    constructor(props) {
        super(props)

        this.onChange = this.onChange.bind(this)
    }

    getOptions() {
        const { categories } = this.props

        const options = [
            {
                label: <T>news.label.all.categories</T>,
                value: null,
            },
            ...Object.values(categories).map(category => ({
                label: category.name,
                value: category.slug,
            })),
        ]

        return options
    }

    onChange({ value }) {
        this.props.history.push(`/news/${value || ''}`)
    }

    render() {
        const { category = {} } = this.props
        const options = this.getOptions()

        return (
            <div className="col-sm-12 filter-container">
                <Select
                    value={options.find(option => option.value === category.slug)}
                    isClearable={false}
                    options={options}
                    onChange={this.onChange}
                />
            </div>
        )
    }
}

const CategoryListMobile = withRouter($CategoryListMobile)

class $SearchBar extends Component {
    constructor(props) {
        super(props)

        this.onClick = this.onClick.bind(this)
        this.onUpdate = this.onUpdate.bind(this)

        this.state = {
            focused: !!this.props.search,
        }
    }

    onClick() {
        this.setState({ focused: true })
    }

    onUpdate(search) {
        const { category, history } = this.props
        history.replace(category ? `/news/${category.slug}` : '/news', undefined, { search })
    }

    render() {
        const { focused } = this.state

        return (
            <div className={`col-lg-4 col-sm-12 search-container ${focused ? 'focused' : ''}`} onClick={this.onClick}>
                {!focused && (
                    <span>
                        <T>news.label.search</T>
                    </span>
                )}

                {focused && (
                    <DelayedInput
                        type="text"
                        placeholder={this.props.translate('news.label.search')}
                        onUpdate={this.onUpdate}
                        value={this.props.search}
                        autoFocus
                    />
                )}

                <i className="search" />
            </div>
        )
    }
}

const SearchBar = compose(withTranslate, withRouter)($SearchBar)

class Header extends Component {
    render() {
        const {
            category,
            categories,
            location: { query },
        } = this.props

        return (
            <div className="col-12 header p-0">
                <div className="row m-0">
                    <MediaQuery minWidth={GRID_BREAKPOINT_MD + 1}>
                        <CategoryList category={category} categories={categories} />
                    </MediaQuery>
                    <MediaQuery maxWidth={GRID_BREAKPOINT_MD}>
                        <CategoryListMobile category={category} categories={categories} />
                    </MediaQuery>

                    <SearchBar search={query.search} category={category} />
                </div>
            </div>
        )
    }
}

export default compose(
    withRouter,
    connect(
        createStructuredSelector({
            category: categorySelector,
            categories: categoriesSelector,
        })
    )
)(Header)
